// src/components/programs/ProgramForm/Step1Sections/ProductsPanel/ProductFilters.jsx

import React from "react";
import { Box, Grid } from "@mui/material";
import FormInput from "../../../../inputs/FormInput";

const ProductFilters = ({
    filters,
    onFilterChange,
    categoriesOptions,
    suppliersOptions,
    loadingCategories,
    loadingSuppliers,
    isArabic,
}) => {
    return (
        <Box>
            <Grid container spacing={1}>
                {/* Search */}
                <Grid item xs={12}>
                    <FormInput
                        label={isArabic ? 'بحث عن منتج...' : 'Search for product...'}
                        value={filters.search}
                        onChange={(e) => onFilterChange('search', e.target.value)}
                        size="small"
                        fullWidth
                    />
                </Grid>

                {/* Category Filter */}
                <Grid item xs={12} md={6}>
                    <FormInput
                        type="select"
                        // label={isArabic ? 'الفئة' : 'Category'}
                        value={filters.category_id}
                        onChange={(e) => onFilterChange('category_id', e.target.value)}
                        options={[
                            { id: '', name: isArabic ? 'جميع الفئات' : 'All Categories' },
                            ...categoriesOptions,
                        ]}
                        disabled={loadingCategories}
                        size="small"
                        fullWidth
                    />
                </Grid>

                {/* Supplier Filter */}
                <Grid item xs={12} md={6}>
                    <FormInput
                        type="select"
                        // label={isArabic ? 'المورد' : 'Supplier'}
                        value={filters.supplier_id}
                        onChange={(e) => onFilterChange('supplier_id', e.target.value)}
                        options={[
                            { id: '', name: isArabic ? 'جميع الموردين' : 'All Suppliers' },
                            ...suppliersOptions,
                        ]}
                        disabled={loadingSuppliers}
                        size="small"
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default ProductFilters;
